import React, { Component } from "react";
import { Button, Collapse, Alert } from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import size from "lodash/size";
import axios from "../../axios";
import * as actionCreators from "./../../modules/actions/index";
import TabBar from "../../components/TabBar/TabBar";
import Search from "../../components/Search/Search";
import map from "lodash/map";
import DateFilter from "../../components/DateFilter/DateFilter";
import ToolsMetricesUI from "./Metrics/ToolkitMetrics";
import ToolsGrid from "./DataGrid/ToolsGrid";
// import DataChartUI from './DataChart/ToolsChart';
import DataChartUI from "./DataChart/Chart";

import Loading from "../../hoc/Loading/Loading";
import * as url from "../../utils/url";
import ExportToCSV from "./ExportToCsv/ExportToCsvTools";
import isEmpty from "lodash/isEmpty";
import { objectEncode } from "../../components/Shared/ReusablesUtils";
import PropTypes from "prop-types";
import "./Analytics.css";

const searchByUserNamePlaceholder = "Search tools...";
const Filters = "Filters";
const chartXAxesMessage =
  "Data on the chart represents weekly aggregates, starting every Monday.";
// Temporary URL for API CALL which needs to be changed when application hosted to DEV server.

// const URL = 'http://10.0.2.155:8090/toolkit/v1/tool-metrics/';

class ToolKitAnalytics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      isFilterCollapsed: false,
      searchObject: {
        metrics: ["noOfShares"],
        // startDate: moment().subtract(1, 'month').toISOString(),
        startDate:
          this.props && this.props.user && this.props.user.organizationId
            ? moment(this.props.user.organizationId.createdDate).toISOString()
            : moment().subtract(1, "month").toISOString(),
        endDate: moment().toISOString(),
        toolname: "",
      },
    };
  }

  componentDidMount() {
    // Fetch Tools tab data
    this.fetchLatestData();
    // Fetching Users Tab Metrices
    this.props.onFetchToolsMetrices();
  }

  modifyDateTimestamp = (momentDate, date) => {
    let dateSplit = momentDate.split("T");
    return `${dateSplit[0]}${
      date === "startDate" ? "T00:00:00Z" : "T23:59:59Z"
    }`;
  };

  fetchLatestData = () => {
    const {
      searchObject: { metrics, startDate, endDate, toolname },
    } = this.state;
    const {
      user: { organizationId },
    } = this.props;
    const getFilterObject = {
      metrics: metrics.toString(),
      startDate: this.modifyDateTimestamp(startDate, "startDate"),
      endDate: this.modifyDateTimestamp(endDate, "endDate"),
      toolname: encodeURIComponent(toolname),
      organizationId: encodeURIComponent(organizationId._id),
    };
    axios
      .get(`${url.getToolKitAnalytics}${objectEncode(getFilterObject)}`)
      .then(({ data }) => {
        this.props.onFetchToolsAnalyticsSuccess(data.data.data);
      });
  };

  toggleCollapse = () => {
    const { isFilterCollapsed } = this.state;
    this.setState({ isFilterCollapsed: !isFilterCollapsed });
  };

  handleSearch = e => {
    const { value } = e.target;
    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          toolname: value,
        },
      },
      () => {
        this.fetchLatestData();
      }
    );
  };

  handleMetricsFilter = (metricId, event) => {
    const { checked } = event.target;
    let { metrics } = this.state.searchObject;

    if (checked && metrics !== undefined) {
      metrics.push(metricId);
    } else {
      metrics.splice(metrics.indexOf(metricId), 1);
    }

    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          metrics,
        },
      },
      () => {
        this.fetchLatestData();
      }
    );
  };

  handlePagination = e => {
    const { value } = e.target;
    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          page: value,
        },
      },
      () => {
        this.fetchLatestData();
      }
    );
  };

  handleStartDateChange = date => {
    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          startDate: date,
        },
      },
      () => {
        const {
          searchObject: { endDate },
        } = this.state;
        if (endDate !== "") {
          this.fetchLatestData();
        }
      }
    );
  };

  handleEndDateChange = date => {
    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          endDate: date,
        },
      },
      () => {
        const {
          searchObject: { startDate },
        } = this.state;
        if (startDate !== "") {
          this.fetchLatestData();
        }
      }
    );
  };

  getCreatedByName = item => {
    if (
      !isEmpty(item.firstName) &&
      !isEmpty(item.lastName) &&
      item["firstName"] !== undefined &&
      item["lastName"] !== undefined
    ) {
      return `${item.firstName} ${item.lastName}`;
    }
    return "NA";
  };

  getExportCSVData = data => {
    const test = [];
    map(data, (d, i) => {
      let a = {
        name: d.name,
        createDate: moment(d.createDate).format("MM/DD/YYYY"),
        createdby: this.getCreatedByName(d.createdBy),
        category: d.category,
        subCategory: d.subCategory,
      };
      test.push(a);
    });
    return test;
  };

  render() {
    const { isFilterCollapsed, searchObject } = this.state;
    const { toolsAnalytics, toolsMetrices, history } = this.props;

    return (
      <div className="mt70 analytics-form">
        <div className="row ml-0 mr-0 mb-3 text-size">
          <div className="title-text">Metrics</div>
          <TabBar activeTab={"3"} history={history} />
        </div>
        <div className="row p-0 m-0 height40">
          <Search
            placeholder={searchByUserNamePlaceholder}
            handleSearch={this.handleSearch}
            value={searchObject.username}
          />
          <div className="col-lg-2 filter-select col-md-3 col-sm-3 pl0 pr0"></div>
        </div>
        {/* <DateFilter
            handleStartDateChange={this.handleStartDateChange}
            handleEndDateChange={this.handleEndDateChange}
            searchObject={searchObject}
        />    */}
        <div className="row p-0 m-0"></div>
        <div>
          <div className="dataChartStyle">
            <div className="dataChartDisplay">
              <DataChartUI
                chartValue="Toolkit"
                chartAnalytics={toolsAnalytics}
                chartMetrices={toolsMetrices}
                searchObject={searchObject}
              />
              <Alert className="btmMargin0" color="light">
                {chartXAxesMessage}
              </Alert>
              <p className="chartUseMsg">
                To zoom in, click and drag across the chart area. To zoom out,
                triple click on the chart area.
              </p>
            </div>
          </div>
          <div className="row">
            {toolsAnalytics.length > 0 && (
              <ExportToCSV
                Analytics={toolsAnalytics}
                userMetrices={toolsMetrices}
              />
            )}
          </div>
        </div>
        <div>
          <ToolsGrid
            user={this.props.user}
            toolsAnalytics={toolsAnalytics}
            toolsMetrices={toolsMetrices}
            searchObject={searchObject}
            onFetchToolsAnalyticsSuccess={
              this.props.onFetchToolsAnalyticsSuccess
            }
          />
        </div>
      </div>
    );
  }
}

ToolKitAnalytics.propTypes = {
  isFilterCollapsed: PropTypes.bool,
  searchObject: PropTypes.object,
  toolsAnalytics: PropTypes.array,
  toolsMetrices: PropTypes.array,
  history: PropTypes.object,
  onFetchToolsAnalyticsSuccess: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    toolsAnalytics: state.dashboard.ToolkitAnalytics,
    toolsMetrices: state.dashboard.ToolkitMetrics,
    user: state.user.profile,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onFetchToolsAnalyticsSuccess: data =>
      dispatch(actionCreators.fetchToolkitAnalyticsSuccess(data)),
    onFetchToolsMetrices: () => dispatch(actionCreators.fetchToolkitMetrices()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(ToolKitAnalytics, axios));
